import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { omit } from 'lodash';

import RestoreFundSearchAlert from 'buyside/graphql/mutations/RestoreUserFundSearchAlert';

import DeletedSavedFundSearches from 'buyside/components/presentation/UserAccount/SavedSearches/deletedSavedFundSearches';

const DeletedSavedFundSearchesContainer = ({ deletedSearches, removeFromSoftDelete }) => (
  <Mutation mutation={RestoreFundSearchAlert}>
    {mutate => {
      const restoreFundSearchAlert = args => mutate({ variables: args });
      return (
        <DeletedSavedFundSearches
          deletedSearches={deletedSearches}
          handleRestoreSearchAlert={({ id, name, active, display, employerProfileSavedSearch }) => {
            removeFromSoftDelete(omit(deletedSearches, id));
            restoreFundSearchAlert({
              name,
              active,
              display,
              employerProfileSavedSearchId: employerProfileSavedSearch.id
            });
          }}
          removeFromSoftDelete={removeFromSoftDelete}
        />
      );
    }}
  </Mutation>
);

export default DeletedSavedFundSearchesContainer;
